import { COMPOSABLE_MAPPING } from "../constants/configure-product-modal";
import { BUNDLE_TYPE_ID, DURATION_MATCHING } from "../constants/product";
import { ConfigureProductModalTalon } from "../types/ConfigureProductModal";

/**
 * @TODO USARE LA PLURALIZZAZIONE DI I18N, NON UN MATCHING DI QUESTO TIPO
 */
export const periodUnits = {
  "M": {
    "singular": "mese",
    "plural": "mesi"
  },
  "Y": {
    "singular": "anno",
    "plural": "anni"
  },
  "B": {
    "singular": "biennio",
    "plural": "bienni"
  },
  "S": {
    "singular": "semestre",
    "plural": "semestri"
  },
  "Q": {
    "singular": "trimestre",
    "plural": "trimestri"
  },
}

export const POSTA_DELIVERY_TYPE = 'Posta';

export const EDICOLA_DELIVERY_TYPE = 'Edicola';

export const MAXIMUN_PRICE_KEY = "maximum_price";

export const deliveryTypes = [POSTA_DELIVERY_TYPE, EDICOLA_DELIVERY_TYPE];

export const getXMLFieldsArray = (xmlBlock, field: string) => {
  try { return xmlBlock[0].children.filter(el => el.name == field); }
  catch (e) { return xmlBlock.children.filter(el => el.name == field); }
}
export const getXMLField = (xmlBlock, field: string) => {
  if (field === 'src' || field === 'alt') {
    const regex = new RegExp(`<${field}>(.*?)<\/${field}>`);
    const match = xmlBlock.match(regex);
    if (match) {
      const data = match[1];
      return data;
    } else {
      return ''
    }
  }
  try {
    const fieldXML = xmlBlock[0].children.find(el => el.name === field);
    return fieldXML ? getXMLFieldContent(fieldXML) : null;
  } catch (er) {
    const fieldXML = xmlBlock && xmlBlock.children ? (xmlBlock.children.find(el => el.name === field)) : null;
    if (!fieldXML) return null;
    return getXMLFieldContent(fieldXML);
  }
};

const getXMLFieldContent = (fieldXML) => {
  if (!fieldXML || !fieldXML.children) return '';

  return fieldXML.children.map(child => {
    if (child.type === 'text') {
      return child.data;
    } else if (child.type === 'tag') {
      return `<${child.name}>${getXMLFieldContent(child)}</${child.name}>`;
    }
    return '';
  }).join('');
};

/** Editorial blcoks for landings functions */
const MD_MAX_COLS = 2;

export const getOddingFactor = (options) => {
  return options.length > 8 ? 4 : 2;
}
export const getMaxCols = (options) => options.length > 8 && options.length % 4 > 0 ? 4 : 5

export const getGridColsNumber = (options) => {
  const MAX_COLS = getMaxCols(options);
  return options.length > MAX_COLS ? MAX_COLS : options.length;
}
export const getMdGridColsNumber = (options) => {
  return options.length > MD_MAX_COLS ? MD_MAX_COLS : options.length;
}

/** Getting if columns are odd to make the last on full span to get all the space available */
export const getColumnsAreOdd = (options) => { return options.length >= getMaxCols(options) && options.length % getOddingFactor(options) != 0; }
export const getColumnsAreMdOdd = (options) => { return options.length >= MD_MAX_COLS && options.length % getOddingFactor(options) != 0; }


/** END Editorial blcoks for landings functions */

export const removeEmptyAttributes = obj => {
  return Object.entries(obj)
    .filter(([_, v]) => v != null)
    .reduce((acc, [k, v]) => ({ ...acc, [k]: v }), {});
}

const getComposableMappingValue = (composable, key, type) => {
  return composable[COMPOSABLE_MAPPING[key][type]] ?? composable[COMPOSABLE_MAPPING[key].landing]; // landing is the fallback
}

export const getComposableProps = (type, composable): ConfigureProductModalTalon => {
  const keysToMap = [
    'landing',
    'setLayoutSelectedPlan',
    'toggleModule',
    'modulesKeys',
    'getChoosenModules',
    'removeModule',
    'setAcceptedQuantities',
    'emptyModules',
    'paymentFrequencyChoosen',
    'mainColor',
    'mainTextColor',
    'showPaymentFrequencySwitcher',
    'selectedPlanLowPaymentFrequency',
    'selectedPlanHighPaymentFrequency',
    'setPaymentFrequencyChoosen',
    'plans',
    'setPaperAdded',
    'setChoosenShippingMethod',
    'paperAdded',
    'choosenShippingMethod',
    'bundleChoosenConfigurableProducts',
    'setSelectedShippingKey',
    'selectedShippingKey',
  ];

  let mapped = {};
  keysToMap.forEach(key => mapped[key] = getComposableMappingValue(composable, key, type))
  return mapped as ConfigureProductModalTalon

}

/**
 * Otput always dd.mm.yyyy
 */
export const formatDate = (date, inputFormat?: string, outputSeparator?: string) => {
  const DATE_SEPARATOR = outputSeparator ?? '.';
  if (inputFormat) {
    const dayIndex = inputFormat.indexOf('DD');
    const monthIndex = inputFormat.indexOf('MM');
    const yearIndex = inputFormat.indexOf('YYYY');
    return `${date.substring(dayIndex, dayIndex + 2)}${DATE_SEPARATOR}${date.substring(monthIndex, monthIndex + 2)}${DATE_SEPARATOR}${date.substring(yearIndex, yearIndex + 4)}`;
  } else {
    const d = new Date(date);
    return `${d.getDate()}${DATE_SEPARATOR}${d.getMonth() + 1}${DATE_SEPARATOR}${d.getFullYear()}`;
  }
};

export const getTrialPeriodLabel = (key, duration) => {
  if (!periodUnits.hasOwnProperty(key)) {
    return "";
  }
  return periodUnits[key][getPluralSingularKey(duration)];
}

const getPluralSingularKey = (duration) => {
  return duration == 1 ? "singular" : "plural";
}

export const getDeliveryCostByDeliveryType = (i18n, $fc, plan, deliveryType) => {
  if (!plan.hasOwnProperty("configurableProducts") ||
    (plan.hasOwnProperty("configurableProducts") && !plan.configurableProducts) &&
    (plan.hasOwnProperty("configurableProducts") && plan.configurableProducts && !Array.isArray(plan.configurableProducts))) {
    return "";
  }
  return plan.configurableProducts.reduce((acc, configurableProduct) => {
    if (!configurableProduct.hasOwnProperty("variants") ||
      (configurableProduct.hasOwnProperty("variants") && !configurableProduct.variants) ||
      (configurableProduct.hasOwnProperty("variants") && configurableProduct.variants && !Array.isArray(configurableProduct.variants))) {
      return "";
    }
    const variant = configurableProduct.variants.find((variant) => {
      return deliveryType == variant.product?.tipo_consegna?.label
    });

    if (!variant ||
      (variant && !variant.product) ||
      (variant && variant.product && !variant.product.price_range) ||
      (variant && variant.product && variant.product.price_range && !variant.product.price_range.maximum_price)) {
      return acc;
    }

    const getDurationLabel = (product) => {

      if (!DURATION_MATCHING.hasOwnProperty(product.tipo_abbonamento)) {
        return "";
      }

      if (!periodUnits.hasOwnProperty(DURATION_MATCHING[product.tipo_abbonamento])) {
        return "";
      }

      return periodUnits[DURATION_MATCHING[product.tipo_abbonamento]]['singular'];
    }

    const price = plan.typeId == BUNDLE_TYPE_ID ?
      getBundleDeliveryPrice(plan, deliveryType) :
      variant.product.price_range.maximum_price.final_price.value;

    const definitivePrice = $fc(price);

    acc = `${definitivePrice} / ${getDurationLabel(variant.product)}`;
    return acc;
  }, "")
}

export const getBundleDeliveryPrice = (plan, deliveryType) => {
  return deliveryType == POSTA_DELIVERY_TYPE ? plan.discountedPricePosta : plan.discountedPriceEdicola;
}

export const elementIsInViewport = (element) => {
  const rect = element.getBoundingClientRect()
  return (
    rect.top >= 0 &&
    rect.left >= 0 &&
    rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
    rect.right <= (window.innerWidth || document.documentElement.clientWidth)
  )
}
